import { useRouter } from 'next/router';
import useModalContext from 'components/context/modal';
import queryString from 'utils/queryString';

const useEditorRouter = productId => {
  const modalContext = useModalContext();

  const router = useRouter();

  return {
    id: router.query.id || productId,

    beforePopState: callback => {
      router.beforePopState(callback);
    },

    async goTo(url) {
      modalContext.setLoading(true);

      await router.push(url, url);

      window.scrollTo(0, 0);
      modalContext.setLoading(false);
    },

    async push(editorUrl = '', params = {}, shallow = true) {
      const queryParams = {
        ...router.query,
        ...params,
      };

      const query = {
        id: queryParams.id,
        version: queryParams.version,
      };

      modalContext.setLoading(true);

      await router.push(
        queryString.stringifyUrl('/editor/[...params]', query),
        queryString.stringifyUrl(`/editor/${productId}${editorUrl}`, query),
        {
          shallow,
        },
      );

      window.scrollTo(0, 0);
      modalContext.setLoading(false);
    },

    async changeProduct(newProductId, version, editorUrl = '') {
      const query = {
        id: router.query.id,
        version,
      };

      modalContext.setLoading(true);

      await router.push(
        queryString.stringifyUrl('/editor/[...params]', query),
        queryString.stringifyUrl(`/editor/${newProductId}${editorUrl}`, query),
        {
          shallow: false,
        },
      );

      window.scrollTo(0, 0);
      modalContext.setLoading(false);
    },

    query: router.query,
  };
};

export default useEditorRouter;
